var map = {
	"./404/8-bit-bkg.svg": 3026,
	"./404/8-bit-cloud-1.svg": 36635,
	"./404/8-bit-cloud-2.svg": 55272,
	"./404/8-bit-cloud-3.svg": 63193,
	"./404/8-bit-cloud-4.svg": 87958,
	"./404/8-bit-finish-line.svg": 22098,
	"./404/8-bit-horse-sprite-1.svg": 48363,
	"./404/8-bit-horse-sprite-2.svg": 90296,
	"./404/8-bit-horse-sprite-3.svg": 15657,
	"./404/8-bit-horse-sprite-4.svg": 46246,
	"./404/8-bit-horse-sprite-5.svg": 35223,
	"./404/8-bit-starting-gate.svg": 46814,
	"./avatars/barry-spears-100x100.jpg": 90440,
	"./avatars/bobby-shoemaker-100x100.jpg": 8207,
	"./avatars/mark-aylward-100x100.jpg": 18175,
	"./avatars/matthew-shifman-100x100.jpg": 54028,
	"./backgrounds/bkg-avatar-checkered.svg": 96455,
	"./backgrounds/bkg-avatar-diagonal.svg": 87606,
	"./backgrounds/bkg-avatar-diamond.svg": 79541,
	"./backgrounds/bkg-avatar-polka-dot.svg": 11442,
	"./backgrounds/bkg-avatar-striped.svg": 1480,
	"./backgrounds/bkg-game-card-complete-derbywars.png": 61113,
	"./backgrounds/bkg-game-card-complete-hrn.png": 83342,
	"./backgrounds/bkg-game-card-complete-nyra-bets.png": 53395,
	"./backgrounds/bkg-game-card-complete-waw.png": 48437,
	"./backgrounds/bkg-game-card-default-derbywars.png": 6965,
	"./backgrounds/bkg-game-card-default-hrn.png": 63770,
	"./backgrounds/bkg-game-card-default-nyra-bets.png": 95687,
	"./backgrounds/bkg-game-card-default-waw.png": 24489,
	"./backgrounds/bkg-game-card-first-place-derbywars.png": 16350,
	"./backgrounds/bkg-game-card-first-place-hrn.png": 13065,
	"./backgrounds/bkg-game-card-first-place-nyra-bets.png": 59956,
	"./backgrounds/bkg-game-card-first-place-waw.png": 26982,
	"./backgrounds/bkg-game-card-second-place-derbywars.png": 89266,
	"./backgrounds/bkg-game-card-second-place-hrn.png": 44525,
	"./backgrounds/bkg-game-card-second-place-nyra-bets.png": 72016,
	"./backgrounds/bkg-game-card-second-place-waw.png": 20578,
	"./backgrounds/bkg-game-card-third-place-derbywars.png": 20403,
	"./backgrounds/bkg-game-card-third-place-hrn.png": 90444,
	"./backgrounds/bkg-game-card-third-place-nyra-bets.png": 86081,
	"./backgrounds/bkg-game-card-third-place-waw.png": 25475,
	"./backgrounds/bkg-game-card-winner-derbywars.png": 7117,
	"./backgrounds/bkg-game-card-winner-hrn.png": 54946,
	"./backgrounds/bkg-game-card-winner-nyra-bets.png": 53823,
	"./backgrounds/bkg-game-card-winner-waw.png": 8849,
	"./backgrounds/bkg-header-waw.png": 26757,
	"./badges/badge-beginner-game.png": 54896,
	"./badges/badge-head-2-head-tournament.png": 68878,
	"./badges/badge-high-stakes-game.png": 3647,
	"./badges/badge-qualifier-tournament.png": 9228,
	"./badges/badge-survivor-contest.png": 3297,
	"./check-diagram.png": 53309,
	"./credit-card-back.png": 24459,
	"./demos/derbywars-demo-game-board-mobile.gif": 80499,
	"./demos/derbywars-demo-game-board.gif": 92092,
	"./demos/derbywars-demo-game-list-mobile.gif": 96107,
	"./demos/derbywars-demo-game-list.gif": 18900,
	"./demos/derbywars-demo-leaderboard-mobile.gif": 91329,
	"./demos/derbywars-demo-leaderboard.gif": 41718,
	"./fans-cheering.jpg": 8271,
	"./favicons/dail-racing-form.ico": 33057,
	"./favicons/derbywars.ico": 6554,
	"./favicons/hrn.ico": 82637,
	"./favicons/nyra-bets.ico": 48540,
	"./favicons/watchandwager.ico": 571,
	"./horse-running-large-gray.gif": 87239,
	"./horse-running-large.gif": 1761,
	"./horse-running-small.gif": 57785,
	"./logos/daily-racing-form-avatar.jpg": 38867,
	"./logos/daily-racing-form-logo-gray.png": 20361,
	"./logos/daily-racing-form-logo.png": 24009,
	"./logos/derbywars-avatar-color.jpg": 42143,
	"./logos/derbywars-avatar-color.svg": 97280,
	"./logos/derbywars-logo-bw-alt.svg": 84202,
	"./logos/derbywars-logo-bw.svg": 52812,
	"./logos/derbywars-logo-color-alt.svg": 1236,
	"./logos/derbywars-logo-color.svg": 74398,
	"./logos/fsta-logo.jpg": 83248,
	"./logos/horse-racing-nation-logo-gray.png": 4410,
	"./logos/horse-racing-nation-logo-white.png": 67968,
	"./logos/horse-racing-nation-logo.png": 65616,
	"./logos/hrn-avatar.svg": 98151,
	"./logos/hrn-logo-horizontal-white.svg": 51494,
	"./logos/hrn-logo-white.svg": 40701,
	"./logos/ntra-logo.png": 93459,
	"./logos/nyra-bets-avatar.jpg": 35883,
	"./logos/nyra-bets-logo-white.png": 42893,
	"./logos/nyra-bets-logo.png": 2161,
	"./logos/paulick-report-logo-gray.png": 14226,
	"./logos/paulick-report-logo.png": 25048,
	"./logos/paypal.png": 17407,
	"./logos/visa-mastercard-logo.jpg": 5622,
	"./logos/waw-avatar.jpg": 93857,
	"./logos/waw-logo.svg": 34380,
	"./marquees/hrn-marquee-1076x224-2x.jpg": 26532,
	"./marquees/open-beta-1076x224-2x.jpg": 66468,
	"./marquees/waw-marquee-1076x224-2x.jpg": 97671,
	"./powered-by-equibase.gif": 22422,
	"./tickets.png": 87066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79369;